export default __webpack_public_path__ + "static/media/settings_img.774e87bd.png";